module.exports = __webpack_public_path__ + "static/media/dcu.bdd2f990.png";